import React from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Box,
    Heading,
    Button,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const ReleasesModal = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    const changelogData = [

        { releaseName: "Version 4.2.0", description: t('infoPage.releaseVersion4.2.0'), date: "08-07-2025" },
        { releaseName: "Version 4.1.0", description: t('infoPage.releaseVersion4.1.0'), date: "23-06-2025" },
        { releaseName: "Version 4.0.0", description: t('infoPage.releaseVersion4.0.0'), date: "05-06-2025" },
        { releaseName: "Version 3.7.0", description: t('infoPage.releaseVersion3.7.0'), date: "19-05-2025" },
        { releaseName: "Version 3.6.0", description: t('infoPage.releaseVersion3.6.0'), date: "08-05-2025" },
        { releaseName: "Version 3.5.0", description: t('infoPage.releaseVersion3.5.0'), date: "22-04-2025" },
        { releaseName: "Version 3.4.0", description: t('infoPage.releaseVersion3.4.0'), date: "14-04-2025" },
        { releaseName: "Version 3.3.0", description: t('infoPage.releaseVersion3.3.0'), date: "07-04-2025" },
        { releaseName: "Version 3.2.0", description: t('infoPage.releaseVersion3.2.0'), date: "31-03-2025" },
        { releaseName: "Version 3.1.0", description: t('infoPage.releaseVersion3.1.0'), date: "14-03-2025" },
        { releaseName: "Version 3.0.0", description: t('infoPage.releaseVersion3.0.0'), date: "10-03-2025" },
        { releaseName: "Version 2.2.1", description: t('infoPage.releaseVersion2.2.1'), date: "17-02-2025" },
        { releaseName: "Version 2.2.0", description: t('infoPage.releaseVersion2.2.0'), date: "12-02-2025" },
        { releaseName: "Version 2.1.0", description: t('infoPage.releaseVersion2.1.0'), date: "30-01-2025" },
        { releaseName: "Version 2.0.0", description: t('infoPage.releaseVersion2.0.0'), date: "17-01-2025" },
        { releaseName: "Version 1.1.0", description: t('infoPage.releaseVersion1.1.0'), date: "11-10-2024" },
        { releaseName: "Version 1.0.0", description: t('infoPage.releaseVersion1.0.0'), date: "11-10-2024" },

    ];

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg" closeOnOverlayClick={false}>
            <ModalOverlay />
            <ModalContent
                maxWidth="85%"
                marginLeft="2%"
                overflow="hidden"
                style={{ top: '10%', left: '2.5%' }}
            >
                <ModalHeader>{t('infoPage.releases')}</ModalHeader>
                <ModalCloseButton />
                <ModalBody maxHeight="400px" overflowY="auto">
                    <Box>
                        <Heading size="md" mb={4}>
                            {t('infoPage.productReleaseHistory')}
                        </Heading>
                        <TableContainer
                            style={{
                                borderRadius: '0.5rem',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
                            }}
                        >
                            <Table variant="striped" sx={{
                                tr: {
                                    "&:nth-of-type(odd)": { bg: "white" },
                                    "&:nth-of-type(even)": { bg: "#b4dbdb" }
                                },
                                td: {
                                    whiteSpace: "normal",
                                    verticalAlign: "top",
                                    minHeight: "48px",
                                    height: "auto",
                                    padding: "1rem"
                                }
                            }}>
                                <Thead>
                                    <Tr>
                                        <Th width="20%">{t('infoPage.releaseName')}</Th>
                                        <Th width="60%">{t('catalog.dataset.description')}</Th>
                                        <Th width="20%">{t('infoPage.date')}</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {changelogData.map((item, index) => (
                                        <Tr key={index}>
                                            <Td className="break-words">{item.releaseName}</Td>
                                            <Td className="break-words">{item.description}</Td>
                                            <Td>{item.date}</Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="blue" onClick={onClose}>
                        {t('infoPage.close')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ReleasesModal;
